<!--
 * @LastEditors: wei ze min
-->
<template>
        <dl class="recommend_nape"  @click="goDetails(item.id, id)">
            <dd>
            <div class="nape_name title" v-html="item.name">
                <!-- <slot name="nape"></slot> -->
            </div>
      <div class="icons">
        <div>
          <div :class="'criteria'+item.preganecy">
            </div>
          <font class="font">备孕</font>
        </div>
        <div>
          <div :class="'criteria'+item.pregnancy">
            </div>
          <font class="font">孕期</font>
        </div>
        <div>
          <div :class="'criteria'+item.confinement">
            </div>
          <font class="font">月子</font>
        </div>
        <div class="icons-doc">
          <div :class="'criteria'+item.lactation">
            </div>
          <font class="font">哺乳</font>
        </div>
        <div>
          <div :class="'criteria'+item.infant">
            </div>
          <font class="font">婴幼儿</font>
        </div>
        <div>
          <div :class="'criteria'+item.nonage">
            </div>
          <font class="font">未成年</font>
        </div>
        <div>
          <div :class="'criteria'+item.middleyounger">
            </div>
          <font class="font">中青年</font>
        </div>
        <div class="icons-doc">
          <div :class="'criteria'+item.quinquagenarian">
            </div>
          <font class="font">老年</font>
        </div>
        
      </div>
            </dd>
            <dt>
            <img v-lazy="item.picture" :key="item.picture" alt="">
            </dt>
        </dl>
</template>

<script>
  

  export default {
    name: 'listiIem',
    props: {
        item: Object,
        id:Number
    },
    methods: {
      goDetails(id, name) {
        this.$emit("goFoodDetails",id,name);
      }
        
    }
  }
</script>

<style lang="less" scoped>
// 分类食物列表

    .classified-list {
        background: #fff;
        border-radius: 8px 8px 0 0;
        padding-left: 10px;
        padding-right: 10px;
        .food-list {
            position: relative;
            .title {
                line-height: 22px;
                color: #333333;
                font-size: 16px;
                padding: 13px 0 7px 0;
                font-weight: 500;
                line-height: 16px;
                >span {
                    font-size: 12px;
                    line-height: 1;
                    color: #888;
                }
            }
            .title-depict {
                width: 216px;
                // line-height: 12px;
                color: #999999;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-bottom: 14px;
                margin-top: -2px;
            }
            .period-details {
                font-size: 14px;
                display: flex;
                padding-bottom: 8px;
                .letters {
                    height: 20px;
                    display: flex;
                    align-items: center;
                    width: 72px;
                    >span {
                        // display: inline-block;
                        margin-left: 3px;
                        // margin-right: 15px;
                    }

                    .checked {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background: url('~@/assets/images/canEat/0.png') no-repeat  left / 100%;
                    }
                    
                    .more {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background: url('~@/assets/images/canEat/1.png') no-repeat  left / 100%;
                    }
                    
                    .warning {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background: url('~@/assets/images/canEat/2.png') no-repeat  left / 100%;
                    }
                    
                    .clear {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background: url('~@/assets/images/canEat/3.png') no-repeat  left / 100%;
                    }
                       
                }
            }
            .food-border {
                width: 52px;
                height: 52px;
                position: absolute;
                right: 0px;
                bottom: 20px;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
                img {
                    width: 52px;
                    height: 52px;
                    display: block;
                    object-fit: cover;
                    border-radius: 4px;
                    overflow: hidden;
                }
            }
            .dividing-line {
                width: 100%;
                height: 1px;
                background: #F2F2F2;
                margin-top: 12px;
            }
        }

    }
.recommend_nape { // dl
  width: 100%;
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px #EEEEEE;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 13px 10px 6px;
  box-sizing: border-box;
  align-items: flex-end;
  dt {
    width: 52px;
    height: 52px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    // margin: 0 auto;
    // margin-top: 7px;
    text-align: center;
    // box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 52px;
      height: 52px;
      display: block;
      object-fit: cover;
      border-radius: 4px;
      overflow: hidden;
    }
  }
  dd {
    width: 100%;
    flex: 1;
    // padding-right: 20px;
    box-sizing: border-box;
    .nape_name {
        // line-height: 22px;
        color: #333333;
        font-size: 16px;
        // padding: 13px 0 7px 0;
        font-weight: 500;
        line-height: 16px;
        >span {
            font-size: 12px;
            line-height: 1;
            color: #888;
        }
      .introduction {
        width: 100%;
        background: #FFFFFF;
        display: -webkit-box;
        overflow: hidden;
        word-break: break-all;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        font-size: 12px;
        color: #999999;
        height: 19px;
        line-height: 26px; // 下面icons给margin边距这里得+margin: 7;
        font-weight: 400;
      }
    }
    .icons {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 7px;
      .icons-doc{
        width: 20%;
      }
      >div {
        width: 26.6%;
        height: 28px;
        padding: 7px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .font {
          font-size: 14px;
          height: 14px;
          color: #333333;
          line-height: 14px;
        }
        >div {
          width: 14px;
          height: 15px;
          margin:2px 4px 4px 0;
        }
        .criteria0{
          background: url(../../../assets/images/canEat/0.png) no-repeat left / 100%;
        }
        .criteria1{
          background: url(../../../assets/images/canEat/1.png) no-repeat left / 100%;
        }
        .criteria2{
          background: url(../../../assets/images/canEat/2.png) no-repeat left / 100%;
        }
        .criteria3{
          background: url(../../../assets/images/canEat/3.png) no-repeat left / 100%;
        }
      }
    }
  }
}

</style>